/**
 * サーバーへ送る表示言語（Accept-Language）。i18n と同じ保存値（localStorage の language）から決める。
 *
 * EV-271（2026-10-11 PM 判断）。axiosInstance を通らない要求（セッションの更新・ログアウト、
 * パスワードの再設定の3画面）も同じ値を送り、エラー文の言語を表示言語にそろえる。
 * 以前はこれらの要求に付けておらず、エラー文の言語はブラウザの言語の設定で決まっていた。
 */
export function requestLanguage(): 'en' | 'ja' {
  return localStorage.getItem('language') === 'en' ? 'en' : 'ja';
}

/** 要求のヘッダに足す Accept-Language。 */
export function languageHeaders(): { 'Accept-Language': 'en' | 'ja' } {
  return { 'Accept-Language': requestLanguage() };
}
